const mapping = [
  // Images
  ["file-image-o", /^image\//],
  // Audio
  ["file-audio-o", /^audio\//],
  // Video
  ["file-video-o", /^video\//],
  // Documents
  ["file-pdf-o", "application/pdf"],
  ["file-text-o", "text/plain"],
  ["file-code-o", ["text/html", "text/javascript"]],
  // Archives
  [
    "file-archive-o",
    [
      /^application\/x-(g?tar|xz|compress|bzip2|g?zip)$/,
      /^application\/x-(7z|rar|zip)-compressed$/,
      /^application\/(zip|gzip|tar)$/,
    ],
  ],
  // Word
  [
    "file-word-o",
    [
      /ms-?word/,
      "application/vnd.oasis.opendocument.text",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ],
  ],
  // Powerpoint
  [
    "file-powerpoint-o",
    [
      /ms-?powerpoint/,
      "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    ],
  ],
  // Excel
  [
    "file-excel-o",
    [
      /ms-?excel/,
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ],
  ],
  // Default, misc
  ["file-o"],
];

function match(mimetype, cond) {
  if (Array.isArray(cond)) {
    return cond.reduce(function (v, c) {
      return v || match(mimetype, c);
    }, false);
  } else if (cond instanceof RegExp) {
    return cond.test(mimetype);
  } else if (cond === undefined) {
    return true;
  } else {
    return mimetype === cond;
  }
}

const cache = {};

function resolve(mimetype) {
  if (cache[mimetype]) {
    return cache[mimetype];
  }

  for (let i = 0; i < mapping.length; i++) {
    if (match(mimetype, mapping[i][1])) {
      cache[mimetype] = mapping[i][0];
      return mapping[i][0];
    }
  }
}

export default function mimetype2fa(mimetype, options) {
  if (typeof mimetype === "object") {
    options = mimetype;
    return function (mimetype) {
      return mimetype2fa(mimetype, options);
    };
  } else {
    const icon = resolve(mimetype);

    if (icon && options && options.prefix) {
      return options.prefix + icon;
    } else {
      return icon;
    }
  }
}



// WEBPACK FOOTER //
// ./src/helpers/MimeIcon.js